export const FETCH_MOSQUEES_REQUEST = 'FETCH_MOSQUEES_REQUEST';
export const FETCH_MOSQUEES_SUCCESS = 'FETCH_MOSQUEES_SUCCESS';
export const FETCH_MOSQUEES_FAILURE = 'FETCH_MOSQUEES_FAILURE';
export const FETCH_MOSQUEES_NEARBY_REQUEST = 'FETCH_MOSQUEES_NEARBY_REQUEST';
export const CREATE_MOSQUEE_REQUEST = 'CREATE_MOSQUEE_REQUEST';
export const CREATE_MOSQUEE_SUCCESS = 'CREATE_MOSQUEE_SUCCESS';
export const CREATE_MOSQUEE_FAILURE = 'CREATE_MOSQUEE_FAILURE';
export const DELETE_MOSQUEE_REQUEST = 'DELETE_MOSQUEE_REQUEST';
export const DELETE_MOSQUEE_SUCCESS = 'DELETE_MOSQUEE_SUCCESS';
export const DELETE_MOSQUEE_FAILURE = 'DELETE_MOSQUEE_FAILURE';
export const UPDATE_MOSQUEE_REQUEST = 'UPDATE_MOSQUEE_REQUEST';
export const UPDATE_MOSQUEE_SUCCESS = 'UPDATE_MOSQUEE_SUCCESS';
export const UPDATE_MOSQUEE_FAILURE = 'UPDATE_MOSQUEE_FAILURE';

export const FETCH_PENDING_MOSQUEES_REQUEST = 'FETCH_PENDING_MOSQUEES_REQUEST';
export const FETCH_PENDING_MOSQUEES_SUCCESS = 'FETCH_PENDING_MOSQUEES_SUCCESS';
export const FETCH_PENDING_MOSQUEES_FAILURE = 'FETCH_PENDING_MOSQUEES_FAILURE';
export const VALIDER_MOSQUEE_REQUEST = 'VALIDER_MOSQUEE_REQUEST';
export const VALIDER_MOSQUEE_SUCCESS = 'VALIDER_MOSQUEE_SUCCESS';
export const VALIDER_MOSQUEE_FAILURE = 'VALIDER_MOSQUEE_FAILURE';
export const REFUSER_MOSQUEE_REQUEST = 'REFUSER_MOSQUEE_REQUEST';
export const REFUSER_MOSQUEE_SUCCESS = 'REFUSER_MOSQUEE_SUCCESS';
export const REFUSER_MOSQUEE_FAILURE = 'REFUSER_MOSQUEE_FAILURE';

export const fetchMosquees = () => ({ type: FETCH_MOSQUEES_REQUEST });
export const fetchMosqueesNearby = (lat, lng, radiusKm) => ({
  type: FETCH_MOSQUEES_NEARBY_REQUEST,
  payload: { lat, lng, radiusKm },
});
export const createMosquee = (data) => ({ type: CREATE_MOSQUEE_REQUEST, payload: data });
export const deleteMosquee = (id) => ({ type: DELETE_MOSQUEE_REQUEST, payload: id });
export const updateMosquee = (id, data) => ({ type: UPDATE_MOSQUEE_REQUEST, payload: { id, data } });
export const fetchPendingMosquees = () => ({ type: FETCH_PENDING_MOSQUEES_REQUEST });
export const validerMosquee = (id) => ({ type: VALIDER_MOSQUEE_REQUEST, payload: id });
export const refuserMosquee = (id) => ({ type: REFUSER_MOSQUEE_REQUEST, payload: id });
